import { createBaseQuery } from '@energy-stacks/shared';
import { createApi } from '@reduxjs/toolkit/query/react';
import { environment } from '@energy-stacks/feature-config';
import { UptimeTimeSliceModel } from './uptimeTimeSliceModel';
import { ChargingSuccessRateSliceModel } from './chargingSuccessRateSliceModel';
import { SessionsNumberAndConsumptionSliceModel } from './sessionsAndConsumptionModel';
import { GetDashboardAnalyticsParams } from './getDashboardAnalyticsParams';
import { addIntervalToDashboardAnalyticsTimeRange } from './addIntervalToDashboardAnalyticsTimeRange';

export const dashboardApi = createApi({
  reducerPath: 'dashboard',
  tagTypes: ['Transactions', 'ChargingStations'],
  baseQuery: createBaseQuery(`${environment.ocppServiceUrl}`),
  endpoints: (builder) => ({
    getUptimeTimeSlices: builder.query<
      UptimeTimeSliceModel[],
      GetDashboardAnalyticsParams
    >({
      query: (queryParams) => ({
        url: '/analytics/connectors/uptime',
        method: 'GET',
        params: addIntervalToDashboardAnalyticsTimeRange(queryParams),
      }),
      keepUnusedDataFor: 0,
    }),

    getChargingSuccessRateTimeSlices: builder.query<
      ChargingSuccessRateSliceModel[],
      GetDashboardAnalyticsParams
    >({
      query: (queryParams) => ({
        url: '/analytics/connectors/sessions/rates',
        method: 'GET',
        params: addIntervalToDashboardAnalyticsTimeRange(queryParams),
      }),
    }),

    getSessionNumberAndConsumptionSlices: builder.query<
      SessionsNumberAndConsumptionSliceModel,
      GetDashboardAnalyticsParams
    >({
      query: (queryParams) => ({
        url: '/analytics/connectors/sessions',
        method: 'GET',
        params: addIntervalToDashboardAnalyticsTimeRange(queryParams),
      }),
    }),
  }),
});

export const {
  useGetUptimeTimeSlicesQuery,
  useGetChargingSuccessRateTimeSlicesQuery,
  useGetSessionNumberAndConsumptionSlicesQuery,
} = dashboardApi;
